module.exports = __webpack_public_path__ + "img/azxy8_bg.f503314c.png";